export const blockIconsImagePhotoCamera = (
	<span className='material-symbols-outlined'>photo_camera</span>
);
